import * as actions from "./actionTypes";
import * as config from "config";

export function bentoLogin(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiBentoLogin,
            method: "post",
            data: params,
            onStart: actions.BENTO_LOGIN_START,
            onSuccess: actions.BENTO_LOGIN,
            onError: actions.BENTO_LOGIN_FAILED,
        },
    }
}

export function finchSaveCode(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiFinchSaveCode,
            method: "post",
            data: params,
            onStart: actions.FINCH_SAVE_CODE_START,
            onSuccess: actions.FINCH_SAVE_CODE,
            onError: actions.FINCH_SAVE_CODE_FAILED,
            baseUrl: "https://crm-stg.earnipay.com/v1",
        },
    }
}

export function finchCheckStatus() {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiFinchCheckStatus,
            method: "get",
            data: {},
            onStart: actions.FINCH_CHECK_STATUS_START,
            onSuccess: actions.FINCH_CHECK_STATUS,
            onError: actions.FINCH_CHECK_STATUS_FAILED,
            baseUrl: "https://crm-stg.earnipay.com/v1",
        },
    }
}
